var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H10.5V1C10.5 0.734784 10.3946 0.48043 10.2071 0.292893C10.0196 0.105357 9.76522 0 9.5 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V9C0.500294 9.09407 0.527117 9.18614 0.577389 9.26565C0.627661 9.34516 0.699341 9.40887 0.784196 9.44947C0.869051 9.49007 0.963638 9.50591 1.05709 9.49517C1.15054 9.48443 1.23907 9.44754 1.3125 9.38875L3.5 7.625V9.5C3.5 9.76522 3.60536 10.0196 3.79289 10.2071C3.98043 10.3946 4.23478 10.5 4.5 10.5H10.3494L12.6875 12.3888C12.776 12.4603 12.8862 12.4996 13 12.5C13.1326 12.5 13.2598 12.4473 13.3536 12.3536C13.4473 12.2598 13.5 12.1326 13.5 12V4C13.5 3.73478 13.3946 3.48043 13.2071 3.29289C13.0196 3.10536 12.7652 3 12.5 3ZM3.15938 6.61125L1.5 7.95312V1H9.5V6.5H3.47375C3.35932 6.50002 3.24835 6.53928 3.15938 6.61125ZM12.5 10.9531L10.8406 9.61125C10.7522 9.53969 10.6419 9.50044 10.5281 9.5H4.5V7.5H9.5C9.76522 7.5 10.0196 7.39464 10.2071 7.20711C10.3946 7.01957 10.5 6.76522 10.5 6.5V4H12.5V10.9531Z",
    fill: "#80898E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.19929b42.svg";
export { ForwardRef as ReactComponent };